import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { DesignateLeadersFromOfficeGroupAction } from '../../domains/leadersManagement/designateLeadersFromOfficeGroupActions.types';

import { DesignateLeadersFromOfficeGroupResults } from './types';

const initialState: DesignateLeadersFromOfficeGroupResults = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<DesignateLeadersFromOfficeGroupResults, DesignateLeadersFromOfficeGroupAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP.PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP.FULFILLED':
      return moveToFulfilled(state, { [action.payload.id]: action.payload });
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP.REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'DESIGNATE_LEADERS_FROM_OFFICE_GROUP.REMOVE_RESULTS':
      return remove(state, [action.payload.id]);
    default:
      return state;
  }
};

export default reducer;
